import DOMPurify from 'dompurify'

export function sanitize(text: string) {
  // eslint-disable-next-line react/no-danger
  return text ? <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} /> : ''
}
